module.exports = __webpack_public_path__ + "img/D2.c919f35c.svg";